import { render, staticRenderFns } from "./ShippingMethodsForOrderTable.vue?vue&type=template&id=551628fa&scoped=true"
import script from "./ShippingMethodsForOrderTable.vue?vue&type=script&lang=js"
export * from "./ShippingMethodsForOrderTable.vue?vue&type=script&lang=js"
import style0 from "./ShippingMethodsForOrderTable.vue?vue&type=style&index=0&id=551628fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551628fa",
  null
  
)

export default component.exports